
import { DisabledPrompt } from "@bcm-dev/bcms-vite";
import { UICheckbox } from "components/ui";
import React from "react";
import { SVGAsset } from "res";

import "./styles.css";

/**
 * @function MobileStateTaxIDTableRow
 * @param {STRING} company - Sets the company name text.
 * @param {STRING} state - Sets the company state text.
 * @param {STRING} taxId - Sets the company tax ID text.
 * @return {React.Component}
 * @exported true
 * @description This is the State tax ID mobile table row used for the main table view.
 */
export default function MobileStateTaxIDTableRow(props) {
  const stateTaxID = props.stateTaxID ?? {};
  const company = props.company ?? "[company]";
  const state = props.state ?? "[state]";
  const taxId = props.taxId ?? "[taxId]";
  const onRowClick = props.onRowClick ?? (() => {});
  const isSelected = props.isSelected === "true";

  return (
    <div className="mobile-state-tax-id-table-row">
      <div className="mobile-state-tax-id-table-row-container flex-container align-center">
        <div className="set-width state-tax-id-checkbox">
          <UICheckbox label="" value={ isSelected } onChange={ onRowClick(stateTaxID) } />
        </div>
        <div className="flex-width state-tax-id-details">
          <div className="state-tax-id-detail-container flex-container company-detail">
            <div className="flex-width">
              <span className="detail-label">Company</span>
            </div>
            <div className="flex-width text-right">
              <span className="detail-text">{company}</span>
            </div>
          </div>
          <div className="state-tax-id-detail-container flex-container state-detail">
            <div className="flex-width">
              <span className="detail-label">State</span>
            </div>
            <div className="flex-width text-right">
              <span className="detail-text">{state}</span>
            </div>
          </div>
          <div className="state-tax-id-detail-container flex-container tax-id-detail">
            <div className="flex-width">
              <span className="detail-label">Tax ID</span>
            </div>
            <div className="flex-width text-right">
              <span className="detail-text">{taxId}</span>
            </div>
          </div>
        </div>
        <div className="set-width actions-detail">
          <DisabledPrompt>
            <SVGAsset id="PencilIcon" className="pencil-icon clickable" />
          </DisabledPrompt>

          <DisabledPrompt>
            <SVGAsset id="TrashcanXIcon" className="trash-can-x-icon clickable"/>
          </DisabledPrompt>
        </div>
      </div>
    </div>
  )
}
